<section class="container-section" *ngIf="!isOpened">
  <div class="row">
    <form class="needs-validation container-style" novalidate [formGroup]="formTransferWorkshopStore">
      <div class="ps-2 pe-2">
        <div class="row pt-1">
          <div class="col">
            <app-custom-button [title]="'Regresar'" [icon]="'pi pi-arrow-left'" [link]="true" [label]="'Regresar'"
              [width]="'6rem'" [routerLink]="['/', url]" [severity]="null"></app-custom-button>
          </div>
          <div class="col d-flex justify-content-sm-center justify-content-end align-items-center">
            <app-navigation (buttonClick)="getButtonClick($event)"></app-navigation>
          </div>

          <div class="col mt-2 mt-sm-0 gap-1 d-flex justify-content-md-end justify-content-center">
            <app-custom-button [title]="'Imprimir'" [severity]="'contrast'" [icon]="'pi pi-print'"
              (onClick)="printPage()"></app-custom-button>
            <app-custom-button [title]="'Eliminar'" [icon]="'pi pi-trash'" [severity]="'contrast'"
              (onClick)="deleteTransferWorkshopStore()"></app-custom-button>

            <app-custom-button class="ms-2" [title]="'Nuevo'" [label]="'Nuevo'" [icon]="'pi pi-plus'" [width]="'5.5rem'"
              [severity]="'success'" [variant]="undefined" (onClick)="createNewRegister()"></app-custom-button>
          </div>
          <hr class="my-1">
        </div>
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-audit-info [userNameCreate]="transferWorkshopStoreContract.userNameCreate"
              [createDate]="transferWorkshopStoreContract.createDate"
              [userNameUpdate]="transferWorkshopStoreContract.userNameUpdate"
              [updateDate]="transferWorkshopStoreContract.updateDate" [reserveSpace]="true"></app-custom-audit-info>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="row">
            <div class="col field-branchId">
              <app-custom-select formControlName="branchId" [labelText]="'Sucursal'" [list]="listBranches"
                [recovery]="true" [required]="true" (onChangeSelect)="changeBranch($event)"></app-custom-select>
            </div>
            <div class="col field-consecutive">
              <app-custom-input-number formControlName="consecutive" [labelText]="'Código'" [required]="true"
                [recovery]="true" (onChangeNumber)="changeConsecutive($event)"></app-custom-input-number>
            </div>
            <div class="col field-alterNumber">
              <app-custom-input-number formControlName="alterNumber"
                [labelText]="'Número Alterno'"></app-custom-input-number>
            </div>
            <div class="col field-dateTransferWorkshopStore">
              <app-custom-datepicker formControlName="dateTransferWorkshopStore"
                [labelText]="'Fecha'"></app-custom-datepicker>
            </div>
            <div class="transfer-state">
              <div class="row">
                <div class="col field-state">
                  <app-custom-tag [label]="'Estado'" [severity]="severityState" [value]="stateTransferStoreWorkshop">
                  </app-custom-tag>
                </div>
                <div class="col field-buttons">
                  <app-custom-button [title]="titleState" [icon]="icon" [severity]="'primary'"
                    (onClick)="changeTransferWorkshopStoreState()">
                  </app-custom-button>
                </div>
                <div class="col field-buttons">
                  <app-custom-button [title]="'Anular Traslado'" [icon]="'pi pi-ban'" [severity]="'warn'"
                    (onClick)="annulTransferWorkshopStore()"></app-custom-button>
                </div>
                <div class="field-checkbox-swBlock">
                  <app-custom-checkbox formControlName="swBlock" [labelText]="'Bloq.'"
                    (onChangeCheckBox)="blockTransferWorkshopStore($event)"></app-custom-checkbox>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col field-type">
              <app-custom-select formControlName="type" [labelText]="'Tipo'" [list]="listTypes" [required]="true"
                (onChangeSelect)="changeTransferWorkshopStoreType($event)"></app-custom-select>
            </div>
            <div class="col field-mechanicId">
              <app-custom-select formControlName="mechanicId" [labelText]="'Mecánico'" [list]="listMechanics"
                [required]="true"></app-custom-select>
            </div>
            <div class="col field-observation">
              <app-custom-textarea formControlName="observation" [labelText]="'Observación'" [autoResize]="false"
                [rows]="1" [maxLength]="250"></app-custom-textarea>
            </div>
            <div class="col field-button-send">
              <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
                [disabled]="disabledForm" (onClick)="onSave()">
              </app-custom-button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <app-transfer-workshop-store-detail [transferWorkshopStoreModel]="transferWorkshopStoreContract"
      [disabledDetail]="disabledForm" (hasQuantityInZero)="hasQuantityInZero = $event"
      [permissionUpdatable]="permissionUpdatable" (emitQuantityDetails)="quantityDetails = $event">
    </app-transfer-workshop-store-detail>
  </div>
</section>

<!-- Impresión -->
<app-print-transfer-workshop-store id="print-transfer-workshop-store" [companyId]="companyId"
  [reloadPrint]="reloadPrint" [transferWorkshopStorePrintModel]="transferWorkshopStorePrintModel" [focusText]="false"
  [editFormat]="false" (finishLoadingPrint)="finishLoading($event)">
</app-print-transfer-workshop-store>

<!-- Modal consecutivo inicial (sin registros) -->
<app-custom-modal #initialConsecutive [header]="'Número de documento inicial'"
  [children]="componentInitialConsecutiveModal" [width]="'25rem'" hidden [output$]="output$">
</app-custom-modal>

<!-- Mensaje de duplicidad ventanas abiertas -->
<div class="container-form d-flex flex-row text-danger" *ngIf="isOpened">
  <span class="material-icons me-1"> highlight_off </span>
  <h6>No se permite tener dos ventanas/pestañas de {{nameWindow}} abiertas.</h6>
</div>